module.exports = __webpack_public_path__ + "static/media/TeamMirror.4959db7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Team/TeamMirror.png
// module id = 335
// module chunks = 0